import React from 'react'
import { useState, useEffect } from 'react'
import './navbar.less'
import Logo from '../../images/Logo.png'
import {GiHamburgerMenu} from 'react-icons/gi'
import {FaFacebookSquare, FaInstagramSquare, FaWhatsappSquare} from 'react-icons/fa'
import { Link } from 'gatsby'

export default ()=>{
    const [navbar, setNavbar] = useState(false);
    const [toggle, setToggle] = useState(false);

    const changeNav = ()=>{
        if (window.pageYOffset > 10){
            setNavbar(true);
        }else{
            setNavbar(false);
        }
    }

    useEffect(()=>{
        window.addEventListener('scroll', changeNav);
    }, []);

    return(
        <nav className={`navbar ${navbar? "active" : ""} ${toggle? "toggle" : ""}`}>
            <div className="nav-container">
                <article className="nav-header">
                    <span onClick={()=>{setToggle(!toggle)}}><GiHamburgerMenu/></span>
                    <Link to="/"><img src={Logo} alt="The Empower Initiative" /></Link>                
                    <div>
                        <span>
                            <a href="https://www.facebook.com/The-Empower-Initiative-105256254781938/">
                                <FaFacebookSquare/>
                            </a>
                        </span>
                        <span>
                            <a href="https://instagram.com/theempowerinitiative.sl?igshid=1ciqeouqyxy6l">
                                <FaInstagramSquare/>
                            </a>
                        </span>
                        <span>
                            <a href="https://wa.me/+94778760802">
                                <FaWhatsappSquare/>
                            </a>
                        </span>
                    </div>
                </article>
                <article className={`links-container ${toggle? "toggle" : ""}`}>
                    <ul className="nav-links">
                        <li>
                            <Link to="/about">About Us</Link>
                        </li>
                        <li>
                            <Link to="/gallery">Events</Link>
                        </li>
                        <li>
                            <a href="https://theempowerinitiative.lk/blog_wp/blog/">Blog</a>
                        </li>
                        <li>
                            <Link to="/contact">Contact Us</Link>
                        </li>
                    </ul>
                </article>
                <article className="social">
                    <span>
                            <a href="https://www.facebook.com/The-Empower-Initiative-105256254781938/">
                                <FaFacebookSquare/>
                            </a>
                        </span>
                        <span>
                            <a href="https://instagram.com/theempowerinitiative.sl?igshid=1ciqeouqyxy6l">
                                <FaInstagramSquare/>
                            </a>
                        </span>
                        <span>
                            <a href="https://wa.me/+94778760802">
                                <FaWhatsappSquare/>
                            </a>
                        </span>
                </article>
            </div>
        </nav>
    )
}